module.exports = __webpack_public_path__ + "static/media/contract-login.84f82e53.svg";